import { render, staticRenderFns } from "./GestionEvaluacionRiesgos.vue?vue&type=template&id=07f7f643&"
import script from "./GestionEvaluacionRiesgos.vue?vue&type=script&lang=js&"
export * from "./GestionEvaluacionRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports